import type { JSX } from "solid-js";
import { cn } from "./utils/cn";

/**
 * Shimmer placeholder. Every data component ships a matching `.Skeleton` that
 * reserves the EXACT height and grid of the loaded version — loading → loaded must
 * be a fade, never a jump.
 */
export function Skeleton(props: { class?: string }): JSX.Element {
  return (
    <div
      aria-hidden="true"
      class={cn("animate-pulse rounded-small bg-[var(--c9-bg-neutral)]", props.class)}
    />
  );
}
